<app-ad-spot [leagueId]="leagueId" [location]="location" [adId]="adId"> </app-ad-spot>
